module.exports = __webpack_public_path__ + "static/media/profile.99520b33.png";